import Vue from 'vue';

Vue.component('sync-index', () =>
    import(/* webpackChunkName: 'sync-index' */ './sync-index.vue'),
);
